<template>

    <div v-if="showDialog" class="modal">
        <div class="overlay" @click="onClose"></div>
        <div>
            <div class=" align-top modal-dialog-centered modal-dialog border-0 rounded-3 ">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">รับของขวัญพรีเมี่ยม</h5>
                        <button type="button" class="btn-close" aria-label="Close" @click="onClose"></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="handleSubmit">
                            <!-- First Name and Last Name -->
                            <div class="mb-3">
                                <label for="firstNameLastName" class="fs-5 mb-1">ชื่อจริง นามสกุล <span
                                        class="text-danger">*</span></label>
                                <input type="text" class="form-control" id="firstNameLastName"
                                    v-model="formData.firstNameLastName" required>
                            </div>

                            <!-- Address Fields -->
                            <div class="mb-3">
                                <label for="houseNumber" class="fs-5 mb-1">บ้านเลขที่ <span
                                        class="text-danger">*</span></label>
                                <input type="text" class="form-control" id="houseNumber" v-model="formData.houseNumber"
                                    required>
                            </div>

                            <div class="mb-3">
                                <label for="group" class="fs-5 mb-1">หมู่</label>
                                <input type="text" class="form-control" id="group" v-model="formData.group">
                            </div>

                            <div class="mb-3">
                                <label for="villageOrAlley" class="fs-5 mb-1">หมู่บ้าน/ซอย</label>
                                <input type="text" class="form-control" id="villageOrAlley"
                                    v-model="formData.villageOrAlley">
                            </div>

                            <!-- Optional Fields -->
                            <div class="mb-3">
                                <label for="building" class="fs-5 mb-1">ตึก/อาคาร</label>
                                <input type="text" class="form-control" id="building" v-model="formData.building">
                            </div>

                            <div class="mb-3">
                                <label for="floor" class="fs-5 mb-1">ชั้น</label>
                                <input type="text" class="form-control" id="floor" v-model="formData.floor">
                            </div>

                            <div class="mb-3">
                                <label for="road" class="fs-5 mb-1">ถนน</label>
                                <input type="text" class="form-control" id="road" v-model="formData.road">
                            </div>

                            <!-- Cascading Address Selection -->
                            <div class="mb-3">
                                <label for="province" class="fs-5 mb-1">จังหวัด <span
                                        class="text-danger">*</span></label>
                                <v-select 
                                    :options="PROVINCE_OPTIONS" 
                                    :reduce="option => option.value" 
                                    label="label"
                                    placeholder="เลือกจังหวัด" 
                                    v-model="formData.province" 
                                    :clearable="false" 
                                    :filterable="true"
                                    required />
                            </div>

                            <div class="mb-3">
                                <label for="district" class="fs-5 mb-1">อำเภอ/เขต <span
                                        class="text-danger">*</span></label>
                                <v-select 
                                    :options="districtOptions" 
                                    :reduce="option => option.value" 
                                    label="label"
                                    placeholder="เลือกอำเภอ/เขต" 
                                    v-model="formData.district" 
                                    :clearable="false" 
                                    :filterable="true"
                                    :disabled="!formData.province"
                                    required />
                            </div>

                            <div class="mb-3">
                                <label for="subDistrict" class="fs-5 mb-1">ตำบล/แขวง <span
                                        class="text-danger">*</span></label>
                                <v-select 
                                    :options="subDistrictOptions" 
                                    :reduce="option => option.value" 
                                    label="label"
                                    placeholder="เลือกตำบล/แขวง" 
                                    v-model="formData.subDistrict" 
                                    :clearable="false" 
                                    :filterable="true"
                                    :disabled="!formData.district"
                                    required />
                            </div>

                            <div class="mb-3">
                                <label for="postalCode" class="fs-5 mb-1">รหัสไปรษณีย์ <span
                                        class="text-danger">*</span></label>
                                <v-select 
                                    :options="postalCodeOptions" 
                                    :reduce="option => option.value" 
                                    label="label"
                                    placeholder="เลือกรหัสไปรษณีย์" 
                                    v-model="formData.postalCode" 
                                    :clearable="false" 
                                    :filterable="true"
                                    :disabled="!formData.subDistrict"
                                    required />
                            </div>

                            <div class="mb-3">
                                <label for="phoneNumber" class="fs-5 mb-1">เบอรโทรศัพท์ <span
                                        class="text-danger">*</span></label>
                                <input type="tel" class="form-control" id="phoneNumber" v-model="formData.phoneNumber"
                                    required>
                            </div>

                            <div class="mb-3">
                                <label for="lineId" class="fs-5 mb-1">LINE ID</label>
                                <input type="text" class="form-control" id="lineId" v-model="formData.lineId">
                            </div>

                            <div class="mb-3">
                                <label for="receiptImage" class="fs-5 mb-1">Upload รูปใบเสร็จ <span
                                        class="text-danger">*</span></label>
                                <input type="file" class="form-control" id="receiptImage" @change="handleFileUpload"
                                    required>
                            </div>
                            <!-- Checkbox for amount bought 1-3 boxes -->
                            <div class="mb-3">
                                <label for="checkbox" class="fs-5 mb-1">จำนวนกล่องในใบเสร็จ<span
                                        class="text-danger">*</span></label>
                                <div class="row">
                                    <div class="col">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="receiptBoxesBought"
                                                id="receiptBoxesBought1" value="1" @click="handleAmountSelect(1)"
                                                :disabled="maxReceiptBoxes < 1">
                                            <label class="form-check-label" for="receiptBoxesBought1">1</label>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="receiptBoxesBought"
                                                id="receiptBoxesBought2" value="2" @click="handleAmountSelect(2)"
                                                :disabled="maxReceiptBoxes < 2">
                                            <label class="form-check-label" for="receiptBoxesBought2">2</label>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="receiptBoxesBought"
                                                id="receiptBoxesBought3" value="3" @click="handleAmountSelect(3)"
                                                :disabled="maxReceiptBoxes < 3">
                                            <label class="form-check-label" for="receiptBoxesBought3">3</label>
                                        </div>
                                    </div>
                                   
                                </div>
                                <div class="text-danger mt-3 fw-light">* กรุณาระบุให้ตรงตามจำนวน NOSMEN ที่ซื้อในใบเสร็จ ไม่งั้นระบบจะล็อคการรับของขวัญ</div>
                            </div>

                            <div class="mb-3">
                                <label class=" fs-5 mt-4 mb-1">ร้านค้าที่ร่วมรายการ<span
                                        class="text-danger">*</span></label>
                                <div class="">
                                    <v-select 
                                        :options="shopOptions"
                                        :reduce="option => option.adjustedId" 
                                        label="label" 
                                        placeholder="เลือกร้านค้า"
                                        v-model="localShop"
                                        :clearable="false"
                                        :searchable="true" />
                                </div>
                                <p class=" text-danger mt-3 mb-0 fw-light">
                                    *กรุณาเลือกชื่อร้านยา ให้ตรงกับใบเสร็จทุกครั้ง
                                </p>
                                <p class=" text-danger mt-1 fw-light">*หากกดรับแล้วไม่สามารถแก้ไขได้ ไม่ว่ากรณีใดๆ</p>
                            </div>

                            <div class="modal-footer d-flex justify-content-center">
                                <button type="submit" class="btn btn-primary"
                                    :disabled="!isFormValid || submitting">ยืนยัน</button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <RewardModal v-if="showRewardModal" @close="showRewardModal = false" /> -->
</template>
<script>
import vSelect from 'vue-select';
import provinces from '@/data/provinces.json';
import amphures from '@/data/amphures.json';
import tambons from '@/data/tambons.json';
// import RewardModal from './RewardModal.vue';

export default {
    name: 'redemption-form',
    components: {
        vSelect,
        // RewardModal
    },
    emits: ['submit', 'update:showDialog', 'update:selectedShop', 'update:isFormComplete', 'show-reward-modal'],
    data() {
        return {
            // showRewardModal: false,
            formData: {
                firstNameLastName: '',
                houseNumber: '',
                group: '',
                villageOrAlley: '',
                building: '',
                floor: '',
                road: '',
                subDistrict: null,
                district: null,
                province: null,
                postalCode: null,
                phoneNumber: '',
                lineId: '',
                receiptImage: null,
                receiptBoxesBought: null,
            },
            localShop: null,
            formValidationState: false,
            districtOptions: [],
            subDistrictOptions: [],
            postalCodeOptions: []
        };
    },
    computed: {
        PROVINCE_OPTIONS() {
            return provinces
                .filter(p => !p.deleted_at)
                .map((p) => ({
                    label: p.name_th,
                    value: p.id,
                }))
                .sort((a, b) => a.label.localeCompare(b.label));
        },
        localSelectedShop: {
            get() {
                return this.localShop;
            },
            set(value) {
                this.localShop = value;
                this.$emit('update:selectedShop', value);
                this.validateForm();
            }
        },
        isFormValid() {
            return this.formValidationState;
        }
    },
    props: {
        showDialog: Boolean,
        shopOptions: Array,
        onClose: {
            type: Function,
            required: true,
        },
        selectedShop: {
            type: [String, Number],
            default: null
        },
        isFormComplete: {
            type: Boolean,
            default: false
        },
        maxReceiptBoxes: {
            type: Number,
            default: 3,
        },
        latestRedemptionData: Object,
        submitting: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        async populateFormWithLatestData() {
            if (!this.latestRedemptionData) return;

            const data = this.latestRedemptionData;
            this.formData.firstNameLastName = data.full_name || '';
            this.formData.houseNumber = data.house_number || '';
            this.formData.group = data.group || '';
            this.formData.villageOrAlley = data.village_or_alley || '';
            this.formData.building = data.building || '';
            this.formData.floor = data.floor || '';
            this.formData.road = data.road || '';
            this.formData.phoneNumber = data.telephone_number || '';
            this.formData.lineId = data.line_id || '';

            if (data.province) {
                const province = provinces.find(p => p.name_th === data.province);
                if (province) {
                    this.formData.province = province.id;
                    await this.$nextTick();

                    if (data.district) {
                        const district = amphures.find(a => a.name_th === data.district && a.province_id === province.id);
                        if (district) {
                            this.formData.district = district.id;
                            await this.$nextTick();

                            if (data.subdistrict) {
                                const subDistrict = tambons.find(t => t.name_th === data.subdistrict && t.amphure_id === district.id);
                                if (subDistrict) {
                                    this.formData.subDistrict = subDistrict.id;
                                    await this.$nextTick();
                                    
                                    if (data.postal_code) {
                                        this.formData.postalCode = parseInt(data.postal_code, 10);
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log('formData', this.formData)
        },
        validateForm() {
            const requiredFields = [
                'firstNameLastName',
                'houseNumber',
                'province',
                'district',
                'subDistrict',
                'postalCode',
                'phoneNumber',
                'receiptImage',
                'receiptBoxesBought'
            ];

            const isComplete = requiredFields.every(field => {
                if (field === 'receiptImage') {
                    return this.formData[field] !== null;
                }
                if (field === 'receiptBoxesBought') {
                    return this.formData[field] !== null && this.formData[field] > 0;
                }
                if (['province', 'district', 'subDistrict', 'postalCode'].includes(field)) {
                    return this.formData[field] !== null && this.formData[field] !== '';
                }
                return this.formData[field] && this.formData[field].trim() !== '';
            });

            this.formValidationState = isComplete && this.localShop !== null;
            console.log('Form validation:', {
                isComplete,
                localShop: this.localShop,
                isFormValid: this.formValidationState,
                formData: this.formData
            });

            this.$emit('update:isFormComplete', this.formValidationState);
            return this.formValidationState;
        },
        handleSubmit() {
            if (this.formValidationState) {
                const provinceName = provinces.find(p => p.id === this.formData.province)?.name_th || '';
                const districtName = amphures.find(a => a.id === this.formData.district)?.name_th || '';
                const subDistrictName = tambons.find(t => t.id === this.formData.subDistrict)?.name_th || '';

                const submissionPayload = {
                    full_name: this.formData.firstNameLastName,
                    house_number: this.formData.houseNumber,
                    group: this.formData.group.trim() || null,
                    village_or_alley: this.formData.villageOrAlley.trim() || null,
                    building: this.formData.building,
                    floor: this.formData.floor,
                    road: this.formData.road,
                    subdistrict: subDistrictName,
                    district: districtName,
                    province: provinceName,
                    postal_code: String(this.formData.postalCode || ''),
                    telephone_number: this.formData.phoneNumber,
                    line_id: this.formData.lineId?.trim() || null,
                    receiptBoxesBought: this.formData.receiptBoxesBought,
                    receiptImage: this.formData.receiptImage,
                };

                this.$emit('submit', submissionPayload);
            }
        },
        displayRewardModal() {
            this.$emit('show-reward-modal');
        },
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                this.formData.receiptImage = file;
                this.validateForm();
            }
        },
        handleAmountSelect(val) {
            this.formData.receiptBoxesBought = val;
            this.validateForm();
        },
    },
    watch: {
        'formData.province'(newProvinceId) {
            // Clear dependent fields
            this.formData.district = null;
            this.districtOptions = [];

            if (newProvinceId) {
                this.districtOptions = amphures
                    .filter(a => a.province_id === newProvinceId && !a.deleted_at)
                    .map(a => ({
                        label: a.name_th,
                        value: a.id
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label));
            }
        },
        'formData.district'(newDistrictId) {
            // Clear dependent fields
            this.formData.subDistrict = null;
            this.subDistrictOptions = [];

            if (newDistrictId) {
                this.subDistrictOptions = tambons
                    .filter(t => t.amphure_id === newDistrictId && !t.deleted_at)
                    .map(t => ({
                        label: t.name_th,
                        value: t.id
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label));
            }
        },
        'formData.subDistrict'(newSubDistrictId) {
            // Clear dependent fields
            this.formData.postalCode = null;
            this.postalCodeOptions = [];

            if (newSubDistrictId) {
                const uniquePostalCodes = [...new Set(
                    tambons
                        .filter(t => t.amphure_id === this.formData.district && !t.deleted_at && t.zip_code)
                        .map(t => t.zip_code)
                )].sort((a, b) => a - b);

                this.postalCodeOptions = uniquePostalCodes.map(code => ({
                    label: code.toString(),
                    value: code
                }));

                // Auto-select postal code if there's only one, or if the sub-district's default zip is available
                if (this.postalCodeOptions.length === 1) {
                    this.formData.postalCode = this.postalCodeOptions[0].value;
                } else {
                    const selectedSubDistrict = tambons.find(t => t.id === newSubDistrictId);
                    if (selectedSubDistrict && uniquePostalCodes.includes(selectedSubDistrict.zip_code)) {
                        this.formData.postalCode = selectedSubDistrict.zip_code;
                    }
                }
            }
        },
        formData: {
            handler() {
                this.validateForm();
            },
            deep: true
        },
        localShop(newValue) {
            this.$emit('update:selectedShop', newValue);
            this.validateForm();
        },
        maxReceiptBoxes(newVal) {
            if (this.formData.receiptBoxesBought > newVal) {
                this.formData.receiptBoxesBought = null;
            }
        },
        latestRedemptionData: {
            handler() {
                this.populateFormWithLatestData();
            },
            immediate: true,
        },
    },
};
</script>


<style scoped>
.modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1050;
    display: block;
    outline: 0;
    overflow-x: hidden;
    overflow-y: auto;
}

.overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 4;
    cursor: pointer;
}

.outer-div,
.modal-dialog {
    position: relative;
    width: auto;
    margin: 0.5rem;
    pointer-events: none;
    z-index: 1055;
    transform: translate(0, 0);
}

.modal-content {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, .2);
    border-radius: 0.3rem;
    outline: 0;
}

.rounded-3 {
    border-radius: 12%;
}

.form-check {
    display: flex;
    align-items: center;
    gap: 12px;
}

.form-check-input {
    margin-top: 0;
}
</style>